export default __webpack_public_path__ + "static/media/Production-House-Logo.70cc2166.jpg";